import { render, staticRenderFns } from "./EMelderComponentMeldenBs8DateiUpload.vue?vue&type=template&id=8bb04512"
import script from "./EMelderComponentMeldenBs8DateiUpload.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs8DateiUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports